// Device types themselves are sourced dynamically from the Firebase RTDB `device_types` node.
// This constant only names the LPR key so the device modal / helpers can special-case it: LPR
// devices carry no access groups, device number, or facility code and are created/edited through a
// separate, CA4K-free endpoint (the vehicle plate is the credential).
// Value is uppercase to match the RTDB `device_types` key (same convention as `RFID`).
export const LPR_DEVICE_TYPE = 'LPR';
